import styled from "styled-components";

export const TruncatedText = styled.p`
  max-width: ${(props) => props.maxWidth ?? "100px"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
`;
